import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-confirm-response',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css']
})
export class ClientComponent implements OnInit {
  option: string | null = null;
  message: string | null = null;
  deviceId: string | null = null;
  notification: string | null = null;
  email: string | null = null;
  userId: string | null = null;
  accessToken: string | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.option = params['option'];
      this.message = params['message'];
      this.deviceId = params['deviceId'];
      this.notification = params['notification'];
      this.email = params['email'];
      this.userId = params['userId'];
      this.accessToken = params['accessToken'];
    });
  }

  confirmAction(): void {
    const apiUrl = `${environment.host}/user/${this.userId}/update-email-ack`;

    const data = {
      status: this.option,
      email: this.email,
      message: this.message,
      kitId: this.deviceId,
      notificationId: this.notification,
    };

    const xhr = new XMLHttpRequest();
    xhr.open('POST', apiUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onload = () => {
      if (xhr.status === 200) {
        const responseData = JSON.parse(xhr.responseText);
        console.log('Response from server:', responseData);
        alert('Status and message sent successfully!');
      } else {
        alert('Error: ' + xhr.status + ' - ' + xhr.statusText);
      }
    };

    xhr.onerror = () => {
      console.error('Request failed');
      alert('There was an error sending the data.');
    };

    xhr.send(JSON.stringify(data));
  }

  declineAction(): void {
    if (!this.email) {
      alert("User email not found.");
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(this.email)) {
      alert("Invalid email format.");
      return;
    }

    const emailDomain = this.email.split('@')[1].toLowerCase();
    let inboxUrl = "";

    if (emailDomain === "gmail.com") {
      inboxUrl = "https://mail.google.com";
    } else if (emailDomain === "outlook.com" || emailDomain === "hotmail.com" || emailDomain === "live.com") {
      inboxUrl = "https://outlook.live.com/mail/";
    } else if (emailDomain === "yahoo.com") {
      inboxUrl = "https://mail.yahoo.com/";
    } else {
      inboxUrl = `https://${emailDomain}`;
    }

    window.location.href = inboxUrl;
  }
}